export interface VerifyGooglePaymentResponse {
  success: boolean;
  subscriptionStatus?: "ACTIVE" | "EXPIRED" | "CANCELED";
  expirationDate?: string;
  message?: string;
  credits?: number; // Updated credits after payment
  subscription?: string; // Subscription type (standard, premium)
}

// Calls backend to verify a Google Play subscription purchase token.
export const verifyGooglePayment = async (accessAuth0Token: string, purchaseToken: string, productId: string): Promise<VerifyGooglePaymentResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/payments/verify-google`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuth0Token}`,
      },
      body: JSON.stringify({ purchaseToken, productId }),
      credentials: "include",
    });

    const data = (await response.json()) as VerifyGooglePaymentResponse;
    if (!response.ok) {
      return {
        success: false,
        message: data?.message || "Google Play verification failed",
      };
    }
    return data;
  } catch (error) {
    console.error("verifyGooglePayment error:", error);
    return { success: false, message: "Network error" };
  }
};
